// extracted by mini-css-extract-plugin
export var marginNegative = "_79-5 _79-3 _79-1";
export var marginPositive = "_79-4 _79-3 _79-1";
export var modalContent = "_79-6";
export var samplesTable = "_79-8";
export var samplesTableContainer = "_79-7";
export var statBox = "_79-a";
export var tableCell = "_79-1";
export var tableCellCenter = "_79-2 _79-1";
export var tableCellRight = "_79-3 _79-1";
export var tableHeader = "_79-0";
export var trackingNumber = "_79-9";